console.log("%c Design & Developed bÿ Sixtudio.","background: black; padding:5px; font-size: 10px; color: #ffffff");
console.log("%c > Site: https://sixtudio.com","background: black; padding:5px; font-size: 10px; color: #ffffff");
console.log("");

/* Product */
document.addEventListener('DOMContentLoaded', function() {
    const productExtraInformation = document.querySelector('#product-extra-information');

    if (productExtraInformation) {
        const accordions = productExtraInformation.querySelectorAll('.accordion');

        accordions.forEach(accordion => {
            const accordionContent = accordion.querySelector('.accordion__content');

            if (accordionContent && accordionContent.textContent.trim() === "####") {
                accordion.remove();
            }
        });
    }
});

/* Footer */
document.addEventListener('DOMContentLoaded', function() {
    const imageBlock = document.querySelector('.footer__block.footer__block--image');
    if (imageBlock) {
        const image = imageBlock.querySelector('img');
        
        const textBlock = document.querySelector('.footer__block.footer__block--text');
        if (textBlock) {
            const vStack = textBlock.querySelector('.v-stack');
            if (vStack && image) {
                vStack.appendChild(image.cloneNode());
            }
        }
    
        imageBlock.parentNode.removeChild(imageBlock);
    }
});
